/** Set at build time via angular.json fileReplacements; undefined = resolve at runtime. */
export const BUILD_ENVIRONMENT_IDENTIFIER: string | undefined = undefined;
